import styled from "@emotion/styled";
import { MenuItemUnstyled, menuItemUnstyledClasses } from "@mui/base";
import { fontRoboto } from "@product/scmp-sdk";

import { Card } from "~/components/common/card";

export const ListboxStyled = styled(Card)`
  padding: 4px;
`;

export const MenuItemStyled = styled(MenuItemUnstyled)`
  padding: 8px;

  color: #666666;
  font-size: 14px;
  font-family: ${fontRoboto};

  list-style: none;

  cursor: default;

  user-select: none;

  &:hover:not(.${menuItemUnstyledClasses.disabled}) {
    color: #000000;
  }

  &.${menuItemUnstyledClasses.focusVisible} {
    color: #2c4692;

    outline: 0;
  }
`;
